import React from "react";
import { useNavigate } from "react-router-dom";
import arrow from "../assets/icons/arrow.svg";
import arrowBlue from "../assets/icons/ArrowBlue.svg";
import "./ArrowButton.css";

const ArrowButton = ({
  text,
  className = "",
  style,
  innerStyle,
  icon,
  onClick,
  link,
  href,
  bgColor,
  textColor,
  type = "button",
  disabled = false,
}) => {
  const navigate = useNavigate();
  const arrowSrc = icon || arrow;

  const handleClick = (e) => {
    if (onClick) onClick(e);
    if (href) {
      // Full-page navigation for external/proxied routes
      window.location.href = href;
    } else if (link) {
      navigate(link);
    }
  };

  const buttonStyle = {
    ...style,
    ...innerStyle,
    ...(bgColor && { background: bgColor }),
    ...(textColor && { color: textColor }),
  };

  return (
    <button
      type={type}
      disabled={disabled}
      className={`arrow-btn ${className}`}
      style={buttonStyle}
      onClick={handleClick}
    >
      <span className="arrow-btn-text">{text}</span>
      <span className="arrow-btn-wrapper">
        <img src={arrowSrc} alt="" className="arrow-btn-icon arrow-main" />
        <img src={arrowSrc} alt="" className="arrow-btn-icon arrow-secondary" />
      </span>
    </button>
  );
};

export default ArrowButton;
